












































































































import Vue from "vue";
import axios from "axios";

export default Vue.extend({
	props: ["jobId"],

	data() {
		return {
         jobInformation: [] as any,
         jobInformationFields: [] as any,
         jobDataGroups: [] as any,
         groupsThatHasData: [] as any,
         langSkills: [] as any,
			loadingJobData: false
      };
	},

   mounted() {
		
	},
   created() {
      axios.get(`keywords/jobinformationfields`)
      .then((r) => {
         this.jobInformationFields = r.data;
      });
   },
	methods: {	
		hideModal() {
			this.$bvModal.hide("crm-job-info");
		},

      getJobInfo(){
			
			this.loadingJobData = true;

         this.jobInformation = [];

 			this.langSkills = [
				{ text: this.$t("native-language"), value: 7 },
				{ text: "C2", value: 6 },
				{ text: "C1", value: 5 },
				{ text: "B2", value: 4 },
				{ text: "B1", value: 3 },
				{ text: "A2", value: 2 },
				{ text: "A1", value: 1 },
			];

         this.jobDataGroups = [
				{"name": "Yritys ja henkilötiedot", "displayName": "Yritys- ja henkilötiedot", "order": 1, "hasData": false},
				{"name": "Työpaikan perustiedot", "displayName": "Työpaikan perustiedot", "order": 2, "hasData": false},
				{"name": "Työpaikan tarkemmat tiedot", "displayName": "Työpaikan tarkemmat tiedot", "order": 3, "hasData": false},
				{"name": "Tehtävän hoitamiseen liittyvät vaatimukset", "displayName": "Tehtävän hoitamiseen liittyvät vaatimukset", "order": 4, "hasData": false},
				{"name": "Muut tiedot", "displayName": "Muut tiedot", "order": 5, "hasData": false}
			];
			this.groupsThatHasData = [];

         

         axios.get(`keywords/crmjobinformation/${this.jobId}`)
         .then((r) => {
            this.jobInformation = r.data;

				this.setGroupHasDataValues();

         });

      },

		decapitalizeFirstLetter(text: string) {
			return text && text[0].toLowerCase() + text.slice(1) || text;
		},

      capitalizeFirstLetter(text: string) {
         return text.charAt(0).toUpperCase() + text.slice(1);
      },

		getFieldValue(fieldId: string){
			var i=0;
			var value = "";		
         
			if(typeof this.jobInformation === 'object' && this.jobInformation !== null){
				if((fieldId + "").toLowerCase()=="ytunnus"){               
               if(this.jobInformation.asiakas !== undefined){
                  let asiakas: any = this.jobInformation.asiakas;               
                  if(asiakas.ytunnus !== undefined){
                     value = asiakas.ytunnus;
                  }
               }            
	         } else if((fieldId + "").toLowerCase()=="jatkuvahaku"){               
					value = this.jobInformation["jatkuvaHaku"];
					if(value + "" == "1" || value + "" == "true"){
						value = String(this.$t("yes"));
					} else {
						value = String(this.$t("no"));
					}
				} else if((fieldId + "").toLowerCase()=="omaauto"){               
					value = this.jobInformation["omaAuto"];
					if(value + "" == "1" || value + "" == "true"){
						value = String(this.$t("yes"));
					} else if (value + "" == "0" || value + "" == "false") {
						value = String(this.$t("no"));
					} else {
						//value = String(this.$t("unknown"));
						value = "";
					}
				} else if((fieldId + "").toLowerCase()=="tyopaikantyypit"){               
					if(this.jobInformation.tyopaikkatyypit !== undefined){
                  let tyypit: any = this.jobInformation.tyopaikkatyypit;               
						for(i=0;i < tyypit.length;i++){
                     if(i > 0){value = value + ", ";}                    
                     value = value + tyypit[i].nimi;
                  }            
               }          
				} else if((fieldId + "").toLowerCase()=="tyosuhde"){               
					if(this.jobInformation.tyosuhteet !== undefined){
                  let suhteet: any = this.jobInformation.tyosuhteet;               
						for(i=0;i < suhteet.length;i++){
                     if(i > 0){value = value + ", ";}                    
                     value = value + suhteet[i].nimi;
                  }            
               }
				} else if((fieldId + "").toLowerCase()=="koulutusjatutkintotaso"){               
					if(this.jobInformation.koulutusJaTutkintoTasot !== undefined){
                  let kjtTasot: any = this.jobInformation.koulutusJaTutkintoTasot;               
						for(i=0;i < kjtTasot.length;i++){
                     if(i > 0){value = value + ", ";}                    
                     value = value + kjtTasot[i].nimi;
                  }            
               }
				} else if((fieldId + "").toLowerCase()=="ajokorttiluokka"){               
					if(this.jobInformation.ajokorttiluokat !== undefined){
                  let akLuokat: any = this.jobInformation.ajokorttiluokat;               
						for(i=0;i < akLuokat.length;i++){
                     if(i > 0){value = value + ", ";}                    
							if(this.$store.state.lang.toLowerCase()==="en"){
								value = value + akLuokat[i].nimiEnglanti;
							} else if (this.$store.state.lang.toLowerCase()==="se") {                     
								value = value + akLuokat[i].nimiRuotsi;
							} else {
								value = value + akLuokat[i].nimi;
							}							
                  }            
               }
				} else if((fieldId + "").toLowerCase()=="edellytykset"){               
					if(this.jobInformation.tyonedellytykset !== undefined){
                  let tyonEdellytykset: any = this.jobInformation.tyonedellytykset;               
						for(i=0;i < tyonEdellytykset.length;i++){
                     if(i > 0){value = value + ", ";}                    
                     value = value + tyonEdellytykset[i].nimi;
                  }            
               }  
				} else if((fieldId + "").toLowerCase()=="ammattiluokka"){               
					if(this.jobInformation.hakuammattialat !== undefined){
                  let hakuammattialat: any = this.jobInformation.hakuammattialat;
						for(i=0;i < hakuammattialat.length;i++){
                     if(i > 0){value = value + ", ";}                     
							if(this.$store.state.lang.toLowerCase()==="en"){
								value = value + hakuammattialat[i].nimiEnglanti;
							} else if (this.$store.state.lang.toLowerCase()==="se") {                     
								value = value + hakuammattialat[i].nimiRuotsi;
							} else {
								value = value + hakuammattialat[i].nimi;
							}							
                  }
               }
				} else if((fieldId + "").toLowerCase()=="atktaidotvalinta"){               
					if(this.jobInformation.itTaidot !== undefined){
                  let itTaidot: any = this.jobInformation.itTaidot;
						for(i=0;i < itTaidot.length;i++){
                     if(i > 0){value = value + ", ";}                     
							if(this.$store.state.lang.toLowerCase()==="en"){
								value = value + itTaidot[i].nimiEnglanti;
							} else if (this.$store.state.lang.toLowerCase()==="se") {                     
								value = value + itTaidot[i].nimiRuotsi;
							} else {
								value = value + itTaidot[i].nimi;
							}							
                  }
               }
				} else if((fieldId + "").toLowerCase()=="ammattikortti"){               
					if(this.jobInformation.lupaJaKorttiKoulutukset !== undefined){
                  let kortit: any = this.jobInformation.lupaJaKorttiKoulutukset;
						for(i=0;i < kortit.length;i++){
                     if(i > 0){value = value + ", ";}                     
							value = value + kortit[i].nimi;						
                  }
               }
				} else if((fieldId + "").toLowerCase()=="tyoaika"){               
					if(this.jobInformation.tyoajat !== undefined){
                  let tyoajat: any = this.jobInformation.tyoajat;
						for(i=0;i < tyoajat.length;i++){
                     if(i > 0){value = value + ", ";}                     
							value = value + tyoajat[i].nimi;						
                  }
               }
				} else if((fieldId + "").toLowerCase()=="kielitaitovalinta"){               
               if(this.jobInformation.kielitaidot !== undefined){                               
                  let kielitaidot: any = this.jobInformation.kielitaidot;
                  for(i=0;i < kielitaidot.length;i++){
                     if(i > 0){value = value + ", ";}
                     var skillLevel: any = this.langSkills.filter((qObj: any)=>{return qObj.value === kielitaidot[i].taitotaso;}).pop();
                     var skillText = "";
                     if(skillLevel !== null && skillLevel !== undefined){
                        skillText = skillLevel.text;
                     }

							if(this.$store.state.lang.toLowerCase()==="en"){
								value = value + kielitaidot[i].nimiEnglanti + " (" + skillText + ")";
							} else if (this.$store.state.lang.toLowerCase()==="se") {                     								
								value = value + kielitaidot[i].nimiRuotsi + " (" + skillText + ")";
							} else {
								value = value + kielitaidot[i].nimi + " (" + skillText + ")";
							}									
                  }                   
               }
				} else if (
								(fieldId + "").toLowerCase()=="tarveilmoitettu" || 
								(fieldId + "").toLowerCase()=="hakuaika" ||
								(fieldId + "").toLowerCase()=="saakka" ||
								(fieldId + "").toLowerCase()=="tyosuhteenalkupvm" ||
								(fieldId + "").toLowerCase()=="tyosuhteenloppupvm"								
							) {
					value = "";
					value = this.jobInformation[String(fieldId)];
               if(value == undefined){               
                  value = this.jobInformation[this.decapitalizeFirstLetter(String(fieldId))];						
               }
					if(value == undefined || value == null){               
						value = "";
					}

					if(value + "" !== ""){
						value = this.formatJobInfoDate(value);
					}


       		} else if((fieldId + "").toLowerCase()=="atktaidot"){
               value = this.jobInformation['atktaidot'];              
            } else {
               value = this.jobInformation[String(fieldId)];
               if(value == undefined){               
                  value = this.jobInformation[this.decapitalizeFirstLetter(String(fieldId))];						
               }
            }
            if(value == undefined || value == null){               
               value = "";
            }
			}
			
			

			return value;
		},

		getFieldTranslation(fieldId: any){
			var fieldName = "";
			if((fieldId+"").toLowerCase()=="ytunnus"){
				fieldName = this.$t("business-ID") + "";
			}
         if((fieldId+"").toLowerCase()=="lisatiedot"){
				fieldName = this.$t("additional-info") + "";
			}
         if((fieldId+"").toLowerCase()=="ammattiluokka"){
				fieldName = this.$t("searchoccupations") + "";
			}
         if((fieldId+"").toLowerCase()=="koulutusjatutkintotaso"){
				fieldName = this.$t("education-and-qualifications") + "";
			}
         if((fieldId+"").toLowerCase()=="koulutustausta"){
				fieldName = this.$t("education-background") + "";
			}
         if((fieldId+"").toLowerCase()=="tyokokemusvuosina"){
				fieldName = this.$t("work-exp-years") + "";
			}
         if((fieldId+"").toLowerCase()=="tyokokemus"){
				fieldName = this.$t("work-experience") + "";
			}
         if((fieldId+"").toLowerCase()=="ajokorttiluokka"){
				fieldName = this.$t("driving-license-class") + "";
			}
         if((fieldId+"").toLowerCase()=="omaauto"){
				fieldName = this.$t("own-car") + "";
			}         
         if((fieldId+"").toLowerCase()=="kielitaitovalinta"){
				fieldName = this.$t("language-skills") + "";
			}
         if((fieldId+"").toLowerCase()=="kielitaito"){
				fieldName = this.$t("language-skills-description") + "";
			}
         if((fieldId+"").toLowerCase()=="atktaidotvalinta"){
				fieldName = this.$t("ict-skills") + "";
			}
         if((fieldId+"").toLowerCase()=="atktaidot"){
				fieldName = this.$t("ict-skills-description") + "";
			}
         if((fieldId+"").toLowerCase()=="ammattikortti"){
				fieldName = this.$t("licenses") + "";
            fieldName = fieldName.toLowerCase();
            fieldName = this.capitalizeFirstLetter(fieldName);
			}
         if((fieldId+"").toLowerCase()=="osaamisenkuvaus"){
				fieldName = this.$t("skill-desc") + "";
            fieldName = fieldName.toLowerCase();
            fieldName = this.capitalizeFirstLetter(fieldName);
			}
         if((fieldId+"").toLowerCase()=="toiveet"){
				fieldName = this.$t("expectations") + "";
			}
         if((fieldId+"").toLowerCase()=="nimike"){
				fieldName = this.$t("work-title") + "";
			}
         if((fieldId+"").toLowerCase()=="tarveilmoitettu"){
				fieldName = this.$t("vacancy-announced") + "";
			}
         if((fieldId+"").toLowerCase()=="tyoaika"){
				fieldName = this.$t("working-hours") + "";
			}
         if((fieldId+"").toLowerCase()=="tyopaikantyypit"){
				fieldName = this.$t("job-type") + "";
			}
         if((fieldId+"").toLowerCase()=="tyosuhde"){
				fieldName = this.$t("employment-relationship") + "";
			}
         if((fieldId+"").toLowerCase()=="hakuaika"){
				fieldName = this.$t("application-period") + "";
			}
         if((fieldId+"").toLowerCase()=="hakuaika"){
				fieldName = this.$t("application-period-begins") + "";
			}
         if((fieldId+"").toLowerCase()=="saakka"){
				fieldName = this.$t("application-period-ends") + "";
			}
         if((fieldId+"").toLowerCase()=="tyosuhteenalkupvm"){
				fieldName = this.$t("employment-begins") + "";
			}
         if((fieldId+"").toLowerCase()=="tyosuhteenloppupvm"){
				fieldName = this.$t("employment-ends") + "";
			}
         if((fieldId+"").toLowerCase()=="tyonkesto"){
				fieldName = this.$t("duration-of-employment") + "";
			}
         if((fieldId+"").toLowerCase()=="paivittainentyoaika"){
				fieldName = this.$t("daily-working-time") + "";
			}
         if((fieldId+"").toLowerCase()=="palkka"){
				fieldName = this.$t("salary") + "";
			}
         if((fieldId+"").toLowerCase()=="tyotehtavat"){
				fieldName = this.$t("work-tasks") + "";
			}
         if((fieldId+"").toLowerCase()=="muuttyotehtavat"){
				fieldName = this.$t("other-possible-tasks") + "";
			}
         if((fieldId+"").toLowerCase()=="edellytykset"){
				fieldName = this.$t("qualifications") + "";
			}
         if((fieldId+"").toLowerCase()=="tyoymparisto"){
				fieldName = this.$t("working-environment") + "";
			}
         if((fieldId+"").toLowerCase()=="tyokoneet"){
				fieldName = this.$t("work-machines") + "";
			}
         if((fieldId+"").toLowerCase()=="yrityksennimi"){
				fieldName = this.$t("company-name") + "";
			}
         if((fieldId+"").toLowerCase()=="yrityksennimi"){
				fieldName = this.$t("company-name") + "";
			}
         if((fieldId+"").toLowerCase()=="paikka"){
				fieldName = this.$t("more-detailed-location-information") + "";
			}
         if((fieldId+"").toLowerCase()=="paikka"){
				fieldName = this.$t("more-detailed-location-information") + "";
			}
         if((fieldId+"").toLowerCase()=="jatkuvahaku"){
				fieldName = this.$t("continuous-employee-search") + "";
			}
			
         // fieldName = fieldName.toLowerCase();
         // fieldName = this.capitalizeFirstLetter(fieldName);
         
         return fieldName;
		},

      setGroupHasDataValues(){
            this.groupsThatHasData = [];
            
            for(var i = 0;i<this.jobInformationFields.length;i++){
               var hasValue = false;   
               
               if(this.jobInformationFields[i].id.toLowerCase()=="tyopaikanosoite"){
                  if( 
                     (this.valueExists(this.jobInformation.asiakas.postiosoite)) ||
                     (this.valueExists(this.jobInformation.asiakas.postinumero)) ||
                     (this.valueExists(this.jobInformation.asiakas.postitoimipaikka)) ||
                     (this.valueExists(this.jobInformation.asiakas.kayntiosoite))                     
                  )
                  {
                     hasValue = true;
                  }						
               } else if (this.jobInformationFields[i].id.toLowerCase()=="edellytykset"){
                  
                  if(
                     (this.valueExists(this.getFieldValue(this.jobInformationFields[i].id))) ||
                     (this.valueExists(this.jobInformation.tyonEdellytykset))
                  )
                  {
                     hasValue = true;
                  }
                     
               
               } else if (this.jobInformationFields[i].id.toLowerCase()=="tyoaika"){
                  if (
							this.valueExists(this.getFieldValue(this.jobInformationFields[i].id)) ||
							this.valueExists(this.jobInformation.tyoaika)
						){
							hasValue = true;
						}


               } else if (this.jobInformationFields[i].id.toLowerCase()=="yhteyshenkilo"){
                  if (
							this.valueExists(this.jobInformation.tyopaikanYhteyshenkilo)
						)
						{
							hasValue = true;
						}
						
               } else {
                  hasValue = this.valueExists(this.getFieldValue(this.jobInformationFields[i].id));
               }


               if(!(this.groupsThatHasData.includes(this.jobInformationFields[i].oletusSijaintiKortilla+""))){
                  if(hasValue == true){
                     this.groupsThatHasData.push(this.jobInformationFields[i].oletusSijaintiKortilla+"");
                     for(var x=0;x<this.jobDataGroups.length;x++){
                        if((this.jobDataGroups[x].name+"").toLowerCase()==(this.jobInformationFields[i].oletusSijaintiKortilla+"").toLowerCase()){
                           this.jobDataGroups[x].hasData = true;
                           break;
                        }
                     }
                  }
               }					


            }

			this.loadingJobData = false;

      },

      valueExists(value: any){
         
         if(value !== null && value !== undefined && value + "" !== ""){            
            // && value + "" !== "undefined" && value + "" !== "null" 
            return true; 
         } else {
            return false; 
         }
      
      },

		formatJobInfoDate(dateString: string){
			
			let dt = new Date(dateString);
			
			var year = dt.getFullYear();
			var month = (dt.getMonth() + 1);
			var day = dt.getDate();

			var tempDate = day + "." + month + "." + year;

			return tempDate;

		}
		
	},
   watch: {
      jobId(){
         if(this.jobId !== 0 && this.jobId !== undefined){
            this.getJobInfo();
         }
      }
   }
});
